import { NgModule } from '@angular/core';
import { HiddenImageOnErrorDirective } from './hidden-image-on-error.directive';

@NgModule({
  declarations: [HiddenImageOnErrorDirective],
  exports: [HiddenImageOnErrorDirective],
})
export class HiddenImageOnErrorModule {}
